"use strict";
/**
 * 浏览器操作cookie
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    /**
     * 获取cookie
     * @param name cookie名称
     */
    get: function (name) {
        var xarr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
        if (xarr != null)
            return decodeURIComponent(xarr[2]);
        return null;
    },
    /**
     * 设置cookie
     * @param key cookie名称
     * @param value cookie的值
     * @param expiredays 过期时间（天）
     * @param domain cookie的domain
     */
    set: function (key, value, expiredays, domain) {
        var cookiestr = key + "=" + escape(value);
        if (expiredays != undefined) {
            var exdate = new Date();
            exdate.setDate(exdate.getDate() + expiredays);
            cookiestr += ";expires=" + exdate.toUTCString();
        }
        if (domain != undefined) {
            cookiestr += ";domain=" + domain;
        }
        cookiestr += ';path=/';
        document.cookie = cookiestr;
    },
    /**
     * 删除cookie
     * @param key cookie名称
     * @param domain cookie的domain
     */
    del: function (key, domain) {
        var exdate = new Date((new Date).getTime() - 1);
        if (domain) {
            document.cookie = key + '=;path=/;expires=' + exdate.toUTCString() + ';domain=' + domain;
        }
        else {
            document.cookie = key + '=;path=/;expires=' + exdate.toUTCString();
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7O0dBRUc7O0FBRUgsa0JBQWU7SUFDYjs7O09BR0c7SUFDSixHQUFHLFlBQUMsSUFBVztRQUNkLElBQUksSUFBSSxHQUFHLFFBQVEsQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLElBQUksTUFBTSxDQUFDLE9BQU8sR0FBRyxJQUFJLEdBQUcsZUFBZSxDQUFDLENBQUMsQ0FBQztRQUMvRSxJQUFJLElBQUksSUFBSSxJQUFJO1lBQ2YsT0FBTyxrQkFBa0IsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUNwQyxPQUFPLElBQUksQ0FBQztJQUNiLENBQUM7SUFDQTs7Ozs7O09BTUc7SUFDSixHQUFHLFlBQUMsR0FBVSxFQUFDLEtBQVksRUFBQyxVQUFrQixFQUFDLE1BQWM7UUFDNUQsSUFBSSxTQUFTLEdBQUcsR0FBRyxHQUFHLEdBQUcsR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUE7UUFFekMsSUFBSSxVQUFVLElBQUksU0FBUyxFQUFFO1lBQzVCLElBQUksTUFBTSxHQUFHLElBQUksSUFBSSxFQUFFLENBQUM7WUFDeEIsTUFBTSxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsT0FBTyxFQUFFLEdBQUcsVUFBVSxDQUFDLENBQUM7WUFDOUMsU0FBUyxJQUFJLFdBQVcsR0FBRyxNQUFNLENBQUMsV0FBVyxFQUFFLENBQUE7U0FDL0M7UUFDRCxJQUFJLE1BQU0sSUFBSSxTQUFTLEVBQUU7WUFDeEIsU0FBUyxJQUFJLFVBQVUsR0FBRyxNQUFNLENBQUE7U0FDaEM7UUFDRCxTQUFTLElBQUksU0FBUyxDQUFBO1FBQ3RCLFFBQVEsQ0FBQyxNQUFNLEdBQUcsU0FBUyxDQUFBO0lBRTVCLENBQUM7SUFDQTs7OztPQUlHO0lBQ0osR0FBRyxZQUFDLEdBQVUsRUFBRSxNQUFjO1FBQzdCLElBQUksTUFBTSxHQUFHLElBQUksSUFBSSxDQUFDLENBQUMsSUFBSSxJQUFJLENBQUMsQ0FBQyxPQUFPLEVBQUUsR0FBRyxDQUFDLENBQUMsQ0FBQztRQUNoRCxJQUFJLE1BQU0sRUFBRTtZQUNYLFFBQVEsQ0FBQyxNQUFNLEdBQUcsR0FBRyxHQUFHLG1CQUFtQixHQUFHLE1BQU0sQ0FBQyxXQUFXLEVBQUUsR0FBRyxVQUFVLEdBQUcsTUFBTSxDQUFDO1NBQ3pGO2FBQ0c7WUFDSCxRQUFRLENBQUMsTUFBTSxHQUFHLEdBQUcsR0FBRyxtQkFBbUIsR0FBRyxNQUFNLENBQUMsV0FBVyxFQUFFLENBQUM7U0FDbkU7SUFFRixDQUFDO0NBQ0QsQ0FBQSJ9